// @flow
import styled, { css } from 'styled-components';
import BreadcrumbsTheme from '../breadcrumbs/theme';
import { media } from '..';

var MainFontColor = function MainFontColor(fontClr) {
  return css(["color:", ";& > *{color:", ";}"], fontClr, fontClr);
};

export var Main = styled.div.withConfig({
  displayName: "styles__Main",
  componentId: "sc-1hrb7yd-0"
})(["", " display:grid;grid-template-areas:'breadcrumbs breadcrumbs' 'content media';grid-template-columns:1fr minmax(0,", ");", " ", "{", " grid-template-areas:", ";grid-template-columns:1fr;}"], function (pr) {
  return pr.fontClr ? MainFontColor(pr.fontClr) : '';
}, function (pr) {
  return pr.media.width;
}, function (pr) {
  return pr.media.position === 'left' ? css(["grid-template-areas:'breadcrumbs breadcrumbs' 'media content';grid-template-columns:minmax(0,", ") 1fr;"], pr.media.width) : '';
}, media.md, function (pr) {
  return pr.fontClrMobile ? MainFontColor(pr.fontClrMobile) : '';
}, function (pr) {
  return pr.mobileImageBelowContent ? '\'breadcrumbs\' \'content\' \'media\' \'cta\'' : '\'breadcrumbs\' \'media\' \'content\' \'cta\'';
});
export var MainBg = styled.div.withConfig({
  displayName: "styles__MainBg",
  componentId: "sc-1hrb7yd-1"
})(["height:70rem;", " display:block;position:relative;", "{", " height:auto;}"], function (pr) {
  return pr.fontClr ? MainFontColor(pr.fontClr) : '';
}, media.md, function (pr) {
  return pr.fontClrMobile ? MainFontColor(pr.fontClrMobile) : '';
});
export var BreadcrumbsEx = Object.assign({}, BreadcrumbsTheme, {
  Main: styled(BreadcrumbsTheme.Main).withConfig({
    displayName: "styles__Main",
    componentId: "sc-1hrb7yd-2"
  })(["grid-area:breadcrumbs;padding:1rem 0;color:inherit;", "{padding-bottom:2rem;}"], media.md),
  Link: styled(BreadcrumbsTheme.Link).withConfig({
    displayName: "styles__Link",
    componentId: "sc-1hrb7yd-3"
  })(["color:inherit;&:hover{color:inherit;}"]),
  Inactive: styled(BreadcrumbsTheme.Inactive).withConfig({
    displayName: "styles__Inactive",
    componentId: "sc-1hrb7yd-4"
  })(["color:inherit;"])
});
var MediaContainerShared = css(["grid-area:media;"]);
export var MediaContainer = styled.div.withConfig({
  displayName: "styles__MediaContainer",
  componentId: "sc-1hrb7yd-5"
})(["", " &>.gatsby-image-wrapper{border-radius:2rem;}", "{display:", ";}"], MediaContainerShared, media.md, function (pr) {
  return pr.hideOnMobile ? 'none' : 'block';
});
export var MediaContainerBg = styled.div.withConfig({
  displayName: "styles__MediaContainerBg",
  componentId: "sc-1hrb7yd-6"
})(["", " position:absolute;top:0;width:100%;height:100%;overflow-y:hidden;& *{width:100%;}", "{display:", ";}"], MediaContainerShared, media.md, function (pr) {
  return pr.hideOnMobile ? 'none' : 'block';
});
var ContentRight = css(["padding:0 10.2rem 0 0;", "{padding:0 5.1rem 0 0;}", "{padding:0;}"], media.max(1300), media.md);
var ContentLeft = css(["padding:0 0 0 10.2rem;", "{padding:0 0 0 5.1rem;}", "{padding:0;}"], media.max(1300), media.md);
var ContentBg = css(["z-index:1;position:relative;&>*{padding-right:40%;", "{padding-right:0;}}"], media.md);

var ContentPadding = function ContentPadding(padding) {
  return css(["padding:", ";"], padding);
};

export var Content = styled.div.withConfig({
  displayName: "styles__Content",
  componentId: "sc-1hrb7yd-7"
})(["", " ", " ", " grid-area:content;display:flex;flex-direction:column;justify-content:", ";align-items:", ";", " ", "{margin-bottom:1rem;}"], function (pr) {
  return pr.media.position === 'right' || !pr.media.position ? ContentRight : '';
}, function (pr) {
  return pr.media.position === 'left' ? ContentLeft : '';
}, function (pr) {
  return pr.media.position === 'bg' ? ContentBg : '';
}, function (pr) {
  return pr.justifyContent;
}, function (pr) {
  return pr.alignItems;
}, function (pr) {
  return pr.content.padding && ContentPadding(pr.content.padding);
}, media.md);
var CtaShared = css(["grid-area:cta;", ""], function (pr) {
  return pr.mobileHideCta ? css(["", "{display:none;}"], media.md) : '';
});
export var CtaInsideContent = styled.div.withConfig({
  displayName: "styles__CtaInsideContent",
  componentId: "sc-1hrb7yd-8"
})(["display:block;", "{display:", ";}", "{margin-top:5rem;& > *{padding-left:0;padding-right:0;}}", ""], media.md, function (pr) {
  return pr.mobileImageBelowContent ? 'none' : 'block';
}, media.md, CtaShared);
export var CtaOutsideContent = styled.div.withConfig({
  displayName: "styles__CtaOutsideContent",
  componentId: "sc-1hrb7yd-9"
})(["display:none;", "{display:", ";}", ""], media.md, function (pr) {
  return pr.mobileImageBelowContent ? 'block' : 'none';
}, CtaShared);